import { render, staticRenderFns } from "./GenerateIV.vue?vue&type=template&id=142e8d1b&scoped=true"
import script from "./GenerateIV.vue?vue&type=script&lang=ts"
export * from "./GenerateIV.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142e8d1b",
  null
  
)

export default component.exports